import type { MiniInterviewType } from 'src/packages/polaris/types';

/* https://metabase.analytics.prod.buoyhealth.com/question/389-mini-interview-lengths */
import StatsFromMetabase from './stats.json';

const STAT_NAME_MAP: Record<MiniInterviewType, string> = {
  dxoc: '(DxoC) Diagnosis of Concern Interview',
  pxoc: '(PxoC) Provider of Concern',
  treatmentGuidance: '(TG) Blog Treatment Guidance',
  txoc: '(TxoC) Treatment of Concern',
  emergency: 'Emergency Interview',
  symptoms: 'Symptom Checker Interview',
  treatment: 'Treatment Interview',
};

const NAME_FIELD = 'INTERVIEW FLOW';
const COUNT_FIELD = 'TOTAL COMPLETED INTERVIEWS, ALL TIME';
const TIME_FIELD = 'AVERAGE TIME (SECONDS), LAST 30 DAYS';

const getStats = () => {
  const stats: { [K in MiniInterviewType]?: { count?: number; time?: number } } = {};
  Object.entries(STAT_NAME_MAP).forEach(([interviewType, label]) => {
    stats[interviewType as MiniInterviewType] = {
      count: StatsFromMetabase.find((stat) => stat[NAME_FIELD] === label)?.[COUNT_FIELD],
      time: StatsFromMetabase.find((stat) => stat[NAME_FIELD] === label)?.[TIME_FIELD],
    };
  });
  return stats;
};

export const STATS = getStats();

// For new interviews we might not want to show all stats
// or even in future iterations show a 'new' tag status
export const NEW_INTERVIEWS = Object.keys(STATS).filter(
  (interviewType) => (STATS[interviewType as MiniInterviewType]?.count || 0) < 1000,
);
